import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'

export default function InventoryOrderDaysCalculator (props) {
  const [weekdaysCount, setWeekdaysCount] = useEnvValue('globals.inventory.delivery_days.weekdays_count', 0)
  const [weekdays, setWeekdays] = useEnvValue('globals.inventory.delivery_days.weekdays', [])
  const [orderForEnd, setOrderForEnd] = useEnvValue('globals.inventory.delivery_days.order_for_end', null)
  const [datesByWeekday] = useEnvValue('globals.inventory.delivery_days.dates', {})

  React.useEffect(() => {
    const endWeekdayIndex = weekdays[weekdays.length - 1]
    const date = datesByWeekday[endWeekdayIndex]

    setOrderForEnd(date || null)
    setWeekdaysCount(weekdays.length)
  }, [weekdays, datesByWeekday])

  return null
}
